<template>
  <p>
    <component :is="weightTag">
      By clicking Place Order, you agree to the Wine Access
      <a href="https://www.wineaccess.com/terms/" target="_blank">
        Terms &amp; Conditions</a
      >
      and
      <a href="https://www.wineaccess.com/privacy-policy/" target="_blank">
        Privacy Policy</a
      >.
    </component>
  </p>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'CheckoutTermsAndConditions',
  props: {
    asBold: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['checkoutState', 'settingsVars', 'addressStateData']),
    weightTag() {
      return this.asBold ? 'strong' : 'span'
    },
  },
}
</script>

<style scoped></style>
